var _style, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1F4498;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,58.1c0.7,6.5-2.4,11.4-7.6,15.2c-6.1,4.5-12.3,8.9-18.5,13.3c-0.6,0.4-1.9,0.4-2.5,0 c-6.3-4.5-12.5-9.1-18.9-13.5c-8.7-6.1-9.5-16.8-5.2-25.2c3.4-6.7,8.2-12.8,12.6-19c3.6-5.1,7.5-9.9,11.3-14.9 c0.8-1,1.5-1.6,2.5-0.2C58.7,24,66.3,34,73.6,44.2C76.4,48.2,77.8,52.9,77.5,58.1z M50.2,66.1c4.8-5.9,9.4-11.3,13.8-16.9 c1.8-2.3,1.5-5.1-0.3-7.5c-4.1-5.7-8.2-11.3-12.3-17c-0.4-0.5-0.7-1-1.1-1.7c-0.8,0.9-1.2,1.3-1.6,1.8c-3.9,5.4-7.9,10.8-11.8,16.3 c-2.5,3.5-2.5,6,0.1,9.4c2.3,3,4.9,5.9,7.4,8.8C46.3,61.5,48.1,63.6,50.2,66.1z M69.9,51.7c-0.3,0.1-0.4,0.1-0.5,0.2 c-4.6,5.9-9.2,11.7-13.7,17.6c-1.6,2.1-1.3,4.4-0.5,7.3c4.3-3.3,8.4-6.3,12.2-9.6C71.7,63.4,72.2,57.7,69.9,51.7z M45.1,76.6 c1.2-3.4,0.8-5.7-1.1-8.1c-4.2-5.3-8.4-10.7-12.5-16c-0.3-0.4-0.4-0.9-0.5-1.3c-0.3,0.2-0.5,0.4-0.8,0.6c-1.2,4.8-2.1,9.6,1.4,13.9 C35.2,70.2,40.4,72.9,45.1,76.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank01);
export default __webpack_public_path__ + "static/media/icon-bank-01.3ee901db9e683c12407d783e8e89a660.svg";
export { ForwardRef as ReactComponent };